import { API_DOMAIN } from "@monorepo/constants";
import { IAgreement } from "@monorepo/types";
import { createApi } from "@reduxjs/toolkit/query/react";

import { customBaseQuery } from "../../helpers/baseQuery";

export const agreementsApi = createApi({
  reducerPath: "agreementsApi",
  baseQuery: customBaseQuery<{
    data: Array<IAgreement>;
    included: Array<IAgreement>;
  }>({
    baseUrl: API_DOMAIN,
  }),
  tagTypes: ["Agreements", "ClientAgreements", "UnauthorizedAgreements"],
  endpoints: (builder) => ({
    unauthorizedAgreements: builder.query<Array<IAgreement>, void>({
      query: () => ({
        url: "/api/v1/agreements/non-authorized",
      }),
      providesTags: ["UnauthorizedAgreements"],
    }),
    agreements: builder.query<Array<IAgreement>, void>({
      query: () => ({
        url: "/api/v1/agreements",
      }),
      providesTags: ["Agreements"],
    }),
    clientAgreementsIds: builder.query<Array<string>, void>({
      query: () => ({
        url: "/api/v1/clients?included=agreements",
      }),
      providesTags: ["ClientAgreements"],
      transformResponse: (response) => response?.included?.map(({ id }) => id),
      extraOptions: {
        serializeResponse: false,
      },
    }),
    updateAgreement: builder.mutation<void, { id: string; value: boolean }>({
      query: ({ id, value }) => {
        const url = `/api/v1/agreements/${id}/${value ? "set" : "unset"}`;
        return {
          url,
          method: "PUT",
        };
      },
      invalidatesTags: (_, error) => {
        /* refetch data only if error occures */
        if (error) {
          return ["ClientAgreements"];
        }
        return [];
      },
    }),
    setAllAgreements: builder.mutation<void, void>({
      query: () => {
        const url = "/api/v1/agreements/set-all";
        return {
          url,
          method: "PUT",
        };
      },
      invalidatesTags: () => {
        return ["ClientAgreements"];
      },
    }),
    unsetAllAgreements: builder.mutation<void, void>({
      query: () => {
        const url = "/api/v1/agreements/unset-all";
        return {
          url,
          method: "PUT",
        };
      },
      invalidatesTags: () => {
        return ["ClientAgreements"];
      },
    }),
  }),
});

export const {
  useUnauthorizedAgreementsQuery,
  useAgreementsQuery,
  useSetAllAgreementsMutation,
  useUnsetAllAgreementsMutation,
  useUpdateAgreementMutation,
  useClientAgreementsIdsQuery,
} = agreementsApi;

export default agreementsApi.reducer;
